import React from 'react'
import { ProjectStatusFragment } from '@/gql/generated/graphql'
import { useQuery } from 'urql'
import { graphql } from '@/gql/generated'
import { useSession } from 'next-auth/react'
import { getProjectStatus, ValidStatusType } from '@utils/project'

export const STATUS_REFRESH_INTERVAL_SECONDS = 30

const getProjectStatusDocument = graphql(/* GraphQL */ `
  query getProjectStatus($projectId: String, $ttl: Int) @cached(ttl: $ttl) {
    projects_metadata(where: { id: { _eq: $projectId } }, limit: 1) {
      ...ProjectStatus
    }
  }
`)

export function useProjectStatus(project?: ProjectStatusFragment | null): {
  status: ValidStatusType
  fetching: boolean
  refetchStatus: () => void
} {
  const { data: session } = useSession()

  const [res, refetchStatusUnsafe] = useQuery({
    query: getProjectStatusDocument,
    variables: {
      projectId: project?.id,
      ttl: session?.user ? 0 : STATUS_REFRESH_INTERVAL_SECONDS
    },
    pause: !project?.id || project.complete,
    requestPolicy: 'network-only'
  })

  // Safe refetch that only executes when we have a valid project ID
  const refetchStatus = React.useCallback(() => {
    if (project?.id && !project.complete) {
      refetchStatusUnsafe()
    }
  }, [project?.id, project?.complete, refetchStatusUnsafe])

  let status = ValidStatusType.upcoming
  if (project) {
    status = getProjectStatus(res.data?.projects_metadata?.[0] ?? project)
  }

  return {
    status,
    fetching: res.fetching,
    refetchStatus
  }
}
